import { faBan } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { OptionProps, SingleValueProps } from 'react-select'
import { components } from 'react-select'

import { mainColors } from '@/styles'
const { Option, SingleValue } = components

interface FrozenIconProps {
	isFrozen: boolean
}

const FrozenIcon = ({ isFrozen }: FrozenIconProps) => {
	if (isFrozen) {
		return (
			<FontAwesomeIcon
				icon={faBan}
				size="sm"
				color={mainColors.frozen}
				title="FROZEN"
				style={{ marginRight: '5px' }}
			/>
		)
	} else {
		return null
	}
}

export const StatusCustomOption = ({
	children,
	...props
}: OptionProps<any, any>) => {
	return (
		<Option {...props}>
			<FrozenIcon isFrozen={props.data.value === 'frozen'} />
			{children}
		</Option>
	)
}

export const StatusCustomSingleValue = ({
	children,
	...props
}: SingleValueProps<any>) => {
	return (
		<SingleValue {...props}>
			<FrozenIcon isFrozen={props.data.value === 'frozen'} />
			{children}
		</SingleValue>
	)
}
